import React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext/AuthContext'
import { loginRoute } from '../../views/Login/route.const'

interface PrivateRouteProps extends RouteProps {
    children?: React.ReactNode
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, ...rest }) => {
    const { isLoggedIn } = useAuth()

    return (
        <Route
            {...rest}
            render={({ location }) =>
                isLoggedIn ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: loginRoute(),
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    )
}

export default PrivateRoute
